module.exports = __webpack_public_path__ + "static/media/Social.115bc28b.jpg";